import type { AiEvent } from "@/hooks/useAiAgent";
import { aiEventDateLabel } from "@/lib/aiEventDate";
import { Badge } from "@/components/ui/badge";

function publicLink(value: string): string | undefined {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password
      ? url.href
      : undefined;
  } catch {
    return undefined;
  }
}

export function AiCollectionEvidence({ event }: { event: AiEvent }) {
  const metadata = event.collectionMetadata;
  if (!metadata) return null;
  return (
    <div className="rounded-md border p-3 text-sm space-y-3">
      <div className="flex flex-wrap gap-2">
        <Badge variant="info">Codex</Badge>
        {metadata.kind === "festival" && (
          <Badge variant="neutral">Festiwal — wydarzenie główne</Badge>
        )}
        {event.parentProposalId && <Badge variant="neutral">Część festiwalu</Badge>}
      </div>
      {!event.date && !(metadata.datePrecision === "date" && metadata.start && metadata.end) && (
        <p className="font-medium">
          Termin źródłowy: {aiEventDateLabel(event)}. Uzupełnij termin przed publikacją.
        </p>
      )}
      {metadata.descriptionUpdatedAt && (
        <p className="text-xs text-muted-foreground">
          Opis uzupełniony na podstawie ponownego odczytu źródła.
        </p>
      )}
      <p className="whitespace-pre-wrap">{metadata.evidence}</p>
      {metadata.missing.length > 0 && (
        <div>
          <p className="font-medium">Do sprawdzenia</p>
          <ul className="list-disc pl-5">
            {metadata.missing.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
      {metadata.priceText && (
        <p>
          <span className="font-medium">Cena ze źródła: </span>
          {metadata.priceText}
        </p>
      )}
      {metadata.registrationText && (
        <p>
          <span className="font-medium">Zapisy ze źródła: </span>
          {metadata.registrationText}
        </p>
      )}
      <div className="flex flex-wrap gap-3">
        {metadata.sourceURLs.map(
          (url, index) =>
            publicLink(url) && (
              <a
                key={url}
                href={publicLink(url)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                Źródło {index + 1}
              </a>
            ),
        )}
        {metadata.imageURLs.map(
          (url, index) =>
            publicLink(url) && (
              <a
                key={url}
                href={publicLink(url)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                Plakat {index + 1}
              </a>
            ),
        )}
      </div>
    </div>
  );
}
